export default __webpack_public_path__ + "f8b681f6fdf8df4e6791f93103903441.png";